import { render, staticRenderFns } from "./webArticle.vue?vue&type=template&id=4341e0d7&"
import script from "./webArticle.vue?vue&type=script&lang=js&"
export * from "./webArticle.vue?vue&type=script&lang=js&"
import style0 from "./webArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports